/**
 * Разделы mini-app, куда ассистент может отправить человека nav-чипом.
 * Единый источник: из него рендерится блок промпта, enum AssistantNavTarget
 * и фронтовый <Link>. Только экраны без path-параметров, достижимые из UI.
 */
export interface AppSection {
  id: string;
  /** Как раздел называется в интерфейсе. */
  title: string;
  /** Одна строка для промпта: что там найти и сделать. */
  hint: string;
  path: string;
  search?: Readonly<Record<string, string>>;
}

export const APP_SECTIONS = [
  { id: 'events', title: 'Ивенты', hint: 'лента событий города', path: '/' },
  { id: 'feed', title: 'Лента', hint: 'новости, события и места города одной лентой', path: '/feed' },
  { id: 'my_events', title: 'Мои события', hint: 'куда я записан и что создал', path: '/my-events' },
  { id: 'create_event', title: 'Создать событие', hint: 'форма нового события', path: '/events/new' },
  { id: 'places', title: 'Места', hint: 'каталог мест города', path: '/places' },
  {
    id: 'people',
    title: 'Люди',
    hint: 'каталог людей для личных знакомств',
    path: '/people',
    search: { tab: 'people' },
  },
  {
    id: 'people_business',
    title: 'Люди · деловое',
    hint: 'деловой каталог людей',
    path: '/people',
    search: { tab: 'people', mode: 'business' },
  },
  {
    id: 'people_incoming',
    title: 'Входящие',
    hint: 'кто лайкнул меня',
    path: '/people',
    search: { tab: 'incoming' },
  },
  {
    id: 'people_circle',
    title: 'Мой круг',
    hint: 'взаимные лайки',
    path: '/people',
    search: { tab: 'circle' },
  },
  { id: 'people_likes', title: 'Лайки', hint: 'кого лайкнул я', path: '/people', search: { tab: 'likes' } },
  {
    id: 'networking_meetings',
    title: 'Встречи',
    hint: 'мои встречи знакомств',
    path: '/networking',
    search: { tab: 'meetings' },
  },
  {
    id: 'networking_dating',
    title: 'Знакомства',
    hint: 'колода анкет для знакомства',
    path: '/networking',
    search: { tab: 'dating' },
  },
  {
    id: 'networking_mutual',
    title: 'Связи · взаимные',
    hint: 'взаимные мэчи',
    path: '/networking',
    search: { tab: 'connections', connectionsView: 'mutual' },
  },
  {
    id: 'networking_intersections',
    title: 'Связи · пересечения',
    hint: 'люди, с которыми меня отметили на одних фото событий',
    path: '/networking',
    search: { tab: 'connections', connectionsView: 'intersections' },
  },
  {
    id: 'networking_contacts',
    title: 'Контакты',
    hint: 'диалоги с моими связями',
    path: '/networking',
    search: { tab: 'contacts' },
  },
  {
    id: 'new_meeting',
    title: 'Новая встреча',
    hint: 'назначить встречу мэчу',
    path: '/networking/new-meeting',
  },
  { id: 'chats', title: 'Чаты', hint: 'все переписки', path: '/chats' },
  { id: 'profile', title: 'Профиль', hint: 'мой экран «Я» и Connection Card', path: '/profile' },
  {
    id: 'profile_editor',
    title: 'Анкета и визитка',
    hint: 'редактор: фото, имя, о себе, интересы, чипы визитки, направления',
    path: '/people/profile',
    search: { mode: 'personal' },
  },
  {
    id: 'profile_context',
    title: 'Мой контекст',
    hint: 'цели, табу, критерии друзей, сферы развития',
    path: '/profile/context/edit',
  },
  { id: 'psych_tests', title: 'Психотесты', hint: 'тесты и Код личности', path: '/profile/psych-tests' },
  { id: 'vectors', title: 'Векторы осознанности', hint: '12 векторов жизни', path: '/profile/vectors' },
  { id: 'mirror', title: 'Зеркало восприятия', hint: 'как меня видят другие', path: '/profile/mirror' },
  {
    id: 'mission',
    title: 'Миссия дня',
    hint: 'игра «Выход из Матрицы»: миссия дня, отчёт, XP и статус',
    path: '/profile/mission',
  },
  {
    id: 'journey',
    title: 'Путь',
    hint: 'игра «Путь»: цель (точка Б), где вы сейчас (точка А), срок и одно задание в день к цели',
    path: '/profile/journey',
  },
  {
    id: 'vip_partner',
    title: 'Gold',
    hint: 'статус Gold: сколько Pro осталось продать и кому они выданы',
    path: '/profile/vip-partner',
  },
  {
    id: 'leela',
    title: 'Лила',
    hint: 'игра «Лила Исток»: разбор вопроса бросками кубика и разговором с проводником',
    path: '/profile/leela',
  },
  { id: 'energy', title: 'Энергия', hint: 'баланс и покупка энергии', path: '/profile/energy' },
  { id: 'notifications', title: 'Уведомления', hint: 'настройки рассылок', path: '/profile/notifications' },
  { id: 'services', title: 'Услуги', hint: 'хаб услуг', path: '/services' },
  { id: 'services_catalog', title: 'Каталог услуг', hint: 'все услуги города', path: '/services/catalog' },
  { id: 'services_mine', title: 'Мои услуги', hint: 'услуги, которые я разместил', path: '/services/mine' },
  { id: 'create_service', title: 'Разместить услугу', hint: 'форма новой услуги', path: '/services/new' },
  { id: 'clubs', title: 'Клубы', hint: 'клубы и сообщества', path: '/clubs' },
  {
    id: 'compatibilities',
    title: 'Мои совместимости',
    hint: 'совместимость с людьми',
    path: '/compatibilities',
  },
] as const satisfies readonly AppSection[];

export type AppSectionId = (typeof APP_SECTIONS)[number]['id'];
export const APP_SECTION_IDS = APP_SECTIONS.map((s) => s.id) as [AppSectionId, ...AppSectionId[]];

export function appSectionById(id: string): AppSection | undefined {
  return APP_SECTIONS.find((s) => s.id === id);
}
